import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { UtilService, VariablesService } from 'src/app/shared/services';

@Component({
  selector: 'app-sip-pitch-card-home',
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule
  ],
  templateUrl: './sip-pitch-card-home.component.html',
  styleUrls: ['./sip-pitch-card-home.component.scss']
})
export class SipPitchCardHomeComponent {
  isMobile = false;
  constructor(
    private vars: VariablesService,
    private util: UtilService
  ) {}
  
  info = {
    topBannerImg: '/assets/images/home-v2/sip-pitch-img.png',
    intro: '',
    title: 'Start Monthly Donation to Save Lives',
    desc: 'With your support, countless children will receive health care and a happy life.',
    birdImg: '/assets/images/home-v2/sip-bird-img.png'
  }

  ngOnInit() {
    this.isMobile = this.util.isMobile();
    if (this.isMobile) {
      this.info.birdImg = '/assets/images/home-v2/sip-bird-img-mweb.png';
      this.info.topBannerImg = '/assets/images/home-v2/sip-pitch-img.png';
      this.info.title = 'Start Monthly Donations that Save Lives';
    }
  }

  redirectTo() {
    const queryParams = {
      'utm_source': 'internal_ketto',
      'utm_medium': 'homepage',
      'utm_content': 'banner'
    }
    this.util.router.navigate(['/new/sip'], {queryParams: queryParams, queryParamsHandling: 'merge'});
  }
}
